const BannerSection = () => {
  return (
    <div class="about-us-banner corzo-page-title-wrap  corzo-style-custom corzo-left-align">
      <div class="corzo-header-transparent-substitute"></div>
      <div class="corzo-page-title-overlay"></div>
      <div class="corzo-page-title-container corzo-container">
        <div class="corzo-page-title-content corzo-item-pdlr">
          <h1
            class="corzo-page-title"
            style={{ fontSize: "46px", marginTop: "10px" }}
          >
            Our Products
          </h1>
          <div class="corzo-page-caption-divider"></div>
        </div>
      </div>
    </div>
  );
};

export default BannerSection;
